<template lang="pug">
div.faq
	h2 F.A.Q.
	ol
		li
			h4 
				span Registration and Payment: 
				em How do I register and pay for the reunion?
			ul
				li Send $75.00 for yourself and an additional $75.00 if you are bringing a guest to Patt Kirkpatrick's Paypal account at the link below.
					.indent
						div <a href="http://cb1970.com/payment" target="_blank">http://cb1970.com/payment</a>
						div Click "Send", Login or create a PayPal account, pay, put your name in the Notes section or mail check payable to:
						.indent.padding
							address
								pre
									| Patt Kirkpatrick – “CB Reunion”
									| 2027 N. Ridge Rd, Perkasie, PA 18944
				li Registration should be completed by Tuesday, April 1st, 2025.
				li Additional Donations are welcome

		li
			h4 
				span Activities:
				em What is the schedule and what are the addresses for the events?
			ul
				li Reunion - Saturday Evening June 7th, 2025 - 55th Class Reunion 6-11 PM
					ul
						li
							address 
								pre
									| The Inn at Fox Briar Farm
									| 300 Carousel Lane
									| Doylestown, PA 18902
						li Attire: Business Casual
				li Unofficial Gathering - Friday Night June 6th, 2025 6-8 PM
					ul
						li
							address
								pre 
									| The Station Tap House
									| 194 W Ashland St
									| Doylestown, PAA 18901
						li Attire: Every day casual
						li Pay as you go
				li Golf Outing - 9 Holes Friday 1:00 PM weather permitting TBD
					ul
						li Doylestown Country Club or other golf club - Contact Brian Vaughn for reservations at Brian's email address below in the Communications Section.
						li Reservations are limited to only 1970 classmates
						li Starting May 13th, remaining openings shall be for guests of classmates
						li Attire: Suitable Golf Clothing and Gear
				
		li 
			h4
				span Volunteer Opportunities:
				em How can a classmate help on the reunion initiative?
			p All volunteers are welcome, please contact Ellen Ponder at ellen.ponder@gmail.com.

		li
			h4
				span Costs:
				em What is and is not covered by the registration fee?
			p Price per person $75.00 includes Dinner Buffet, Dessert, DJ, Dancing at the Inn at Fox Briar Farm.
			p The registration fee does not cover the cash bar (wine and beer only) at reunion or any other activities such as golf.

		li 
			h4
				span Communications:
				em What is the best way to communicate with the committee?
			.indent
				div <span>General:</span> Ellen Ponder at <a href="mailto:cb50threunionclassof1970@gmail.com">cb50threunionclassof1970@gmail.com</a>
				div <span>Golf:</span> Brian Vaughan at <a href="mailto:b.vaughan@jarrettvaughan.com">b.vaughan@jarrettvaughan.com</a>

		li
			h4
				span Survey:
				em What is the purpose of the survey and is it required?
			p The online survey is entirely optional. The committee is providing an opportunity for classmates to learn what their fellow classmates have been doing. We decided upon a virtual survey so we could all communicate in an organized manner.

		li
			h4 
				span Accommodations:
				em What are local hotels to book?
			table
				tr
					th
						h5 Doylestown Inn
					td
						address
							pre
								| 18 W. State St.
								| Doylestown, Pa.
								| (215) 345-6610
								| Free Parking if reserved at booking
				tr
					th
						h5 Hargrave House B&amp;B
					td
						address
							pre
								| 50 S. Main St.
								| Doylestown, Pa.
								| (215) 348-3334
								| Breakfast included, free parking, free cancellation, 10% discount AAA &amp; AARP
				tr
					th
						h5 Holiday Inn Express
					td
						address
							pre
								| 240 Veterans Way Warminister, Pa
								| (215) 443-4300
								| Free continental breakfast
				tr
					th
						h5 Hampton Inn
					td
						address
							pre
								| 1570 Easton Rd.
								| Warrington, Pa.
								| (215) 343-8400
								| Free breakfast, free cancellation
				tr
					th
						h5 Homewood Suites by Hilton
					td
						address
							pre
								| 2650 Kelley Rd.
								| Warrington, Pa.
								| (215) 343-1300
								| Free hot breakfast, free parking, indoor pool

		li
			h4
				span Refunds:
				em Is there a policy on refunds in the case of inability to attend or cancellation of the event?
			p If for any reason the reunion is cancelled, the committee will utilize our best efforts to return any unspent fees on a pro-rata basis. If an individual informs the Committee of cancellation before May 7th and the Committee can obtain a refund from the venue such amount shall be refunded. There shall be no refunds for cancellation after May 7th.
		li
			h4
				span Attendance:
				em Is there a limit on attendees?
			p The reunion is limited to 200 attendees. The first classmates and guests registered shall reserve their places. The committee welcomes only Class of 1970 graduates and their one permitted guest to attend.

</template>

<script>

export default {
	name: 'Faq',
	components: {
	},
	data () {
		return {
		}
	}
}
</script>


<style lang="stylus" scoped>
h4
	span
		text-decoration underline
		display inline-block
		margin-right 5px
	em
		font-weight normal
h5
	font-size inherit
	margin 0
	
.indent
	padding-left 40px
	span
		text-decoration underline
		display inline-block
		margin-right 5px
	&.padding
		padding 20px
table
	th
		padding-right 20px
	th,
	td
		vertical-align top
		padding-bottom 40px
pre
	font-family inherit
	font-size inherit
	font-style normal
	margin 0
	white-space break-spaces
</style>